(function() {
  App.angularApp.directive('mfCarousel', [
    '$window', '$timeout', '$parse', function($window, $timeout, $parse) {
      var MfCarouselCtrl;
      return {
        restrict: 'E',
        scope: {
          mfCarouselOptions: '&mfCarouselOptions'
        },
        link: function($scope, ele, attrs, $carousel) {
          ele.find('mf-carousel-content').addClass('mf-carousel-content');
          return $carousel.options = angular.extend({
            pixelsPerClick: 50,
            durationOfClick: 100
          }, $scope.mfCarouselOptions());
        },
        controller: [
          '$scope', '$element', MfCarouselCtrl = (function() {
            function MfCarouselCtrl($scope, $element) {
              this.content = $element.find('mf-carousel-content');
            }

            MfCarouselCtrl.prototype.scrollLeft = function() {
              return this.content.animate({
                scrollLeft: this.content.scrollLeft() - this.options.pixelsPerClick
              }, this.options.durationOfClick, 'linear');
            };

            MfCarouselCtrl.prototype.scrollRight = function() {
              return this.content.animate({
                scrollLeft: this.content.scrollLeft() + this.options.pixelsPerClick
              }, this.options.durationOfClick, 'linear');
            };

            return MfCarouselCtrl;

          })()
        ]
      };
    }
  ]);

  App.angularApp.directive('mfCarouselLeft', [
    '$window', '$timeout', '$parse', function($window, $timeout, $parse) {
      return {
        restrict: 'E',
        require: '^^mfCarousel',
        link: function($scope, ele, attrs, $carousel) {
          var intervalIds;
          ele.addClass('mf-carousel-left');
          intervalIds = [];
          ele.mousedown(function(evnt) {
            if (evnt.button !== 0) {
              return;
            }
            $carousel.scrollLeft();
            return intervalIds.push(setInterval(function() {
              return $carousel.scrollLeft();
            }, $carousel.options.durationOfClick));
          });
          return ele.mouseup(function(evnt) {
            var results;
            results = [];
            while (intervalIds.length > 0) {
              results.push(clearInterval(intervalIds.pop()));
            }
            return results;
          });
        }
      };
    }
  ]);

  App.angularApp.directive('mfCarouselRight', [
    '$window', '$timeout', '$parse', function($window, $timeout, $parse) {
      return {
        restrict: 'E',
        require: '^^mfCarousel',
        link: function($scope, ele, attrs, $carousel) {
          var intervalIds;
          ele.addClass('mf-carousel-right');
          intervalIds = [];
          ele.mousedown(function(evnt) {
            if (evnt.button !== 0) {
              return;
            }
            $carousel.scrollRight();
            return intervalIds.push(setInterval(function() {
              return $carousel.scrollRight();
            }, $carousel.options.durationOfClick));
          });
          return ele.mouseup(function(evnt) {
            var results;
            results = [];
            while (intervalIds.length > 0) {
              results.push(clearInterval(intervalIds.pop()));
            }
            return results;
          });
        }
      };
    }
  ]);

}).call(this);
